import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ValidationMessage from '../validation/ValidationMessage';

class Input extends Component {
    constructor(props) {
        super(props);
        const value = props.defaultValue || '';
        this.state = {
            value,
            touched: typeof props.defaultValue === 'string' && props.defaultValue.length > 0,
            valid: this.hasValidationFn(props) && value ? props.isValid(value) : undefined,
            manualFocus: false,
        };
      
    }

    hasValidationFn = props => props && typeof props.isValid === 'function';

    onChange = event => {
        const value = event.target.value;
        //console.log(value)
        
        this.setState({
            value,
            valid: this.hasValidationFn(this.props) ? this.props.isValid(value) : undefined
        });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    getSpacers = () =>
        typeof this.props.spacers === 'number' ? `spacer-bottom-${this.props.spacers}` : '';

    onBlur = () => {
        if (this.state.value !== '') {
            this.setState({
                valid: this.hasValidationFn(this.props)
                    ? this.props.isValid(this.state.value)
                    : undefined,
                touched: true
            });
        }
    };

    success = () => (this.state.touched || this.props.submitted) && this.state.valid;

    error = () => (this.state.touched || this.props.submitted) && !this.state.valid;

    renderValidationIcon = () => {
        if (this.success()) {
            return (
                <img
                    className="validation-icon"
                    src={require('../style/img/icons/success.svg')}
                    alt="Success icon"
                />
            );
        } else if (this.error()) {
            return (
                <img
                    className="validation-icon"
                    src={require('../style/img/icons/error.svg')}
                    alt="Error icon"
                />
            );
        }
    };

    render() {
        const {
            autoComplete,
            autoFocus,
            className,
            defaultValue,
            id,
            label,
            name,
            type,
            validationMessage,
            disabled,
        } = this.props;

        return (
            <div
                className={`inn-input-text ${classNames(
                    { 'has-value': this.state.value },
                    className
                )} ${this.getSpacers()}`}
            >
                <input
                    type={type}
                    id={id}
                    key={id}
                    className={classNames(
                        { success: this.hasValidationFn() && this.success() },
                        { error: this.hasValidationFn() && this.error() }
                    )}
                    name={name}
                    defaultValue={defaultValue}
                    onBlur={this.onBlur}
                    autoComplete={autoComplete}
                    autoFocus={autoFocus || false}
                    onChange={this.onChange}
                    disabled={disabled}
                />
                <label htmlFor={id}>{label}</label>

                {this.renderValidationIcon()}

                <ValidationMessage visible={!!this.error()} text={validationMessage || ''} />
            </div>
        );
    }
}

Input.defaultProps = {
    type: 'text',
    disabled: false
};

Input.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    spacers: PropTypes.number,
    isValid: PropTypes.func,
    validationMessage: PropTypes.string,
    submitted: PropTypes.bool,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

export default Input;
